import StepperItem, { StepperItemProps } from './StepperItem';

export type { StepperItemProps };
export default StepperItem;
